import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Dashboard from './pages/Dashboard';
import AppointmentList from './pages/AppointmentList';
import AppointmentDetails from './pages/AppointmentDetails';
import AppointmentForm from './components/AppointmentForm';
import TemplateList from './pages/TemplateList';
import TemplateDetails from './pages/TemplateDetails';
import TemplateEditor from './pages/TemplateEditor';
import Login from './pages/Login';
import ProfilePage from './pages/ProfilePage';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Navbar />
          <main className="App-main">
            <Routes>
              {/* Routes publiques */}
              <Route path="/login" element={<Login />} />
              
              {/* Routes protégées */}
              <Route path="/" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/appointments" element={
                <ProtectedRoute>
                  <AppointmentList />
                </ProtectedRoute>
              } />
              <Route path="/appointments/new" element={
                <ProtectedRoute>
                  <AppointmentForm mode="create" />
                </ProtectedRoute>
              } />
              <Route path="/appointments/:id" element={
                <ProtectedRoute>
                  <AppointmentDetails />
                </ProtectedRoute>
              } />
              <Route path="/appointments/:id/edit" element={
                <ProtectedRoute>
                  <AppointmentForm mode="edit" />
                </ProtectedRoute>
              } />
              
              {/* Routes pour les modèles */}
              <Route path="/templates" element={
                <ProtectedRoute>
                  <TemplateList />
                </ProtectedRoute>
              } />
              <Route path="/templates/new" element={
                <ProtectedRoute>
                  <TemplateEditor mode="create" />
                </ProtectedRoute>
              } />
              <Route path="/templates/:id" element={
                <ProtectedRoute>
                  <TemplateDetails />
                </ProtectedRoute>
              } />
              <Route path="/templates/:id/edit" element={
                <ProtectedRoute>
                  <TemplateEditor mode="edit" />
                </ProtectedRoute>
              } />
              
              {/* Route pour le profil utilisateur */}
              <Route path="/profile" element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              } />
              
              {/* Redirection par défaut */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
